var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"rgb(255 255 255)","min-height":"100vh"},attrs:{"id":"app"}},[(_vm.$store.state.loader == true)?_c('Loader'):_vm._e(),_c('router-view'),_c('ModalGeneral')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }